/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the hook used to retrieve the Theme Manager Context.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Enables the use of grade data loaded from the ServiceStack API.
 */
import { SubtermsAndGradesSelectors, useSubtermsAndGradesSelector } from 'src/store/reducers/subtermsAndGrades';

/**
 * Typings
 */
import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const useSubtermsAndGradesIndividualGrade = (
    termId: number,
    gradeId: number
): [
    Dtos.Grade | null
] => {
    const grade = useSubtermsAndGradesSelector(state => SubtermsAndGradesSelectors.selectGradeFromView(state, termId, gradeId));

    return [
        grade
    ];
};

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default useSubtermsAndGradesIndividualGrade;


// WEBPACK FOOTER //
// ./src/hooks/useSubtermsAndGradesIndividualGrade.ts